import { ComponentProps } from 'react';
import { usePlanFeatureSummaries } from '../hooks/usePlanFeatureSummaries';
import { WelcomeCardFeature } from './WelcomeCardFeature';

// Feature rows for the given target plans only, in the given order
export const WelcomeCardPlanFeatures: React.FC<WelcomeCardPlanFeaturesProps> = ({ plans }) => {
    const summaries = usePlanFeatureSummaries();

    return (
        <>
            {plans.map(({ handle, label, icon }) => {
                const plan = summaries.find((summary) => summary.handle === handle);
                if (!plan) return null;

                return (
                    <WelcomeCardFeature key={handle} icon={icon} label={label}>
                        {plan.summary}
                    </WelcomeCardFeature>
                );
            })}
        </>
    );
};

export interface WelcomeCardTargetPlan {
    /** `handle` of the Shopify pricing plan, e.g. "starter" */
    handle: string;
    /** Displayed plan name, e.g. "Starter" */
    label: string;
    icon?: ComponentProps<'s-icon'>['type'];
}

interface WelcomeCardPlanFeaturesProps {
    plans: WelcomeCardTargetPlan[];
}
